import fromAnyToString from 'utils/converters/fromAnyToString';

const fromAnyToNumber = (string) => (Array.isArray(string) ? NaN : Number.parseFloat(fromAnyToString(string)));

export default fromAnyToNumber;
